<template functional>
  <nav
    :class="[data.class, data.staticClass, 'sf-breadcrumbs']"
    :style="[data.style, data.staticStyle]"
    v-bind="data.attrs"
    :aria-label="props.ariaLabel"
    v-on="listeners"
  >
    <ol class="sf-breadcrumbs__list">
      <li
        v-for="(breadcrumb, i) in props.breadcrumbs"
        :key="i"
        class="sf-breadcrumbs__list-item"
        :aria-current="
          $options.breadcrumbLast(props.breadcrumbs) === i && 'page'
        "
      >
        <template v-if="$options.breadcrumbLast(props.breadcrumbs) !== i">
          <slot name="link" v-bind="{ breadcrumb }">
            <component
              :is="injections.components.SfLink"
              class="sf-breadcrumbs__breadcrumb"
              :link="breadcrumb.link"
              :data-testid="breadcrumb.text"
            >{{breadcrumb.text}}</component>
          </slot>
        </template>
        <template v-else>
          <slot name="current" v-bind="{ breadcrumb }">
            <component
              :is="injections.components.SfLink"
              :link="breadcrumb.link"
              class="sf-breadcrumbs__breadcrumb current"
            >{{breadcrumb.text}}</component>
          </slot>
        </template>
      </li>
    </ol>
  </nav>
</template>
<script>
import SfLink from "@storefront-ui/vue/src/components/atoms/SfLink/SfLink.vue";
export default {
  name: "SfBreadcrumbs",
  inject: {
    components: {
      default: { SfLink },
    },
  },
  props: {
    breadcrumbs: {
      type: Array,
      default: () => [],
    },
    ariaLabel: {
      type: String,
      default: "breadcrumb",
    },
  },
  breadcrumbLast(breadcrumbs) {
    return breadcrumbs.length - 1;
  },
};
</script>
<style lang="scss">
@import "~@storefront-ui/shared/styles/components/atoms/SfBreadcrumbs.scss";

.sf-breadcrumbs__list-item:not(:last-child)::after {
  content: "/";
  text-decoration: none;
  color: #1d1f22;
}

a.sf-link.sf-breadcrumbs__breadcrumb {
  text-decoration: underline;
  color: #1d1f22;
  &.current {
    text-decoration: none;
  }
}

.desktop-breadcrumb,
.mobile-breadcrumb {
    & .current {
        text-decoration: underline!important;
    }
}
</style>
